import Axios from "axios";

// export const baseURL = "http://localhost:5051/api";
export const baseURL = "https://m2admin.softkuka.com.br/api";
// export const baseURL = "https://m2devadmin.softkuka.com.br/api";
export const DEPLOY_URL = "https://m2admin.softkuka.com.br";

const api = Axios.create({
  baseURL,
});

api.interceptors.request.use(async (config: any) => {
  if (window.localStorage.getItem("token")) {
    const token = window.localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
